<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-4"></div>

      <div class="col-lg-4">
        <div class="card">
          <p class="title">Spel afronden</p>
          <div class="row">
            <div class="col">
              <p>
                Na het afronden kan je het spel nog eenmalig opstarten om het einde van het spel te laten zien aan de
                leerlingen.
              </p>
              <button class="btn btn-sandpiper" @click="showOutro = true;">Spel afronden</button>
            </div>
          </div>
        </div>

      </div>

      <div class="col-lg-4"></div>

    </div>


  </div>

  <OutroPopup v-if="showOutro && buddyData.id !== null" :open="showOutro" :buddy="buddyData"
              @nextStepClicked="closePopup"></OutroPopup>

</template>

<script>

import OutroPopup from "@/components/StudentPlatform/Onboarding/OutroPopup";
import { MirrorParts } from "@/mixins/MirrorParts";
import AccessoryLibrary from "@/mixins/AccessoryLibrary";
import { AID } from "@/enums/AccessoryIdEnum";
import { BuddyApi } from "sandpiper_api";

export default {
  name: "EndGameConfirmation",
  components: { OutroPopup },
  watch: {
    buddyData: {
      handler()
      {
        if (this.buddyData.bodyPartIds !== undefined && this.buddyData.bodyPartIds['head'] !== '')
        {
          //this.showLoadIcon = false;

          //mirror all body parts and accessories that need to be mirrored
          for (const part in MirrorParts)
          {
            if (part in this.buddyData.bodyPartIds)
            {
              if (this.buddyData.bodyPartIds[MirrorParts[part]] !== this.buddyData.bodyPartIds[part])
              {
                this.buddyData.bodyPartIds[MirrorParts[part]] = this.buddyData.bodyPartIds[part];
              }
            }

            if (part in this.buddyData.accessoryIds)
            {
              if (this.buddyData.accessoryIds[MirrorParts[part]] !== this.buddyData.accessoryIds[part])
              {
                this.buddyData.accessoryIds[MirrorParts[part]] = this.buddyData.accessoryIds[part];
              }
            }
          }

          let sleeve = AccessoryLibrary.getSleeveForShirtId(this.buddyData.accessoryIds[AID.SHIRT].name);
          if (sleeve && this.buddyData.accessoryIds['sleeve_left'].id !== sleeve.id)
          {
            this.buddyData.accessoryIds['sleeve_left'] = sleeve;
            this.buddyData.accessoryIds['sleeve_right'] = sleeve;
          }
          else if (!sleeve && this.buddyData.accessoryIds['sleeve_left'].id !== '')
          {
            this.buddyData.accessoryIds['sleeve_left'] = { name: '', id: '' };
            this.buddyData.accessoryIds['sleeve_right'] = { name: '', id: '' };
          }

        }
      },
      deep: true,
    },
  },
  props: {},
  inject: [ "doApiRequest" ],

  data()
  {
    return {
      buddyId: null,
      showOutro: false,
      buddyData: {
        name: null,
        id: null,
        fitness: {
          posture: 0,
          colorVibrancy: 0,
          animation: 0,
        },
        avatar: null,
        buddyConfig: {
          className: '',
          school: {
            id: null,
            name: '',
            postalCode: '',
          },
          schoolYear: {
            endDate: null,
            startDate: null,
          },
          studentCount: null,
        },
        expNextLevel: null,
        experience: null,
        level: null,
        bodyPartIds: {
          head: { name: 'head', id: "" },
          head_fuzz: { name: 'head_fuzz', id: "" },
          head_wrinkles: { name: 'head_wrinkles', id: "" },
          body_wrinkles: { name: 'body_wrinkles', id: "" },
          eyes: { name: 'eyes-01', id: "" },
          antenna: { name: 'antenna-01', id: "" },
          snout: { name: 'snout', id: "" },
          whiskers: { name: 'whiskers-05', id: "" },
          nose: { name: 'nose-01', id: "" },
          mouth: { name: 'mouth-01', id: "" },
          middle: { name: 'body', id: "" },
          ear_left: { name: 'ears-01', id: "" },
          ear_right: { name: 'ears-01', id: "" },
          arm_left: { name: 'arm', id: "" },
          arm_right: { name: 'arm', id: "" },
          leg_left: { name: 'leg', id: "" },
          leg_right: { name: 'leg', id: "" },
          eyebrow_left: { name: 'eyebrow', id: "" },
          eyebrow_right: { name: 'eyebrow', id: "" },
          tail: {name: 'tail', id: ""},

        },
        accessoryIds: {
          hat: { name: '', id: "" },
          shirt: { name: '', id: "" },
          sleeve_left: { name: '', id: "" },
          sleeve_right: { name: '', id: "" },
          shoe_left: { name: '', id: "" },
          shoe_right: { name: '', id: "" },
          hand: { name: '', id: "" },
          pants: { name: '', id: "" },
        },
        colors: {
          buddy_primary: '',
          buddy_secondary: '',
          buddy_tertiary: '',
          accessory_primary: '',
          accessory_secondary: '',
          accessory_tertiary: '',
        }
      },

    }
  },
  methods: {
    async fetchBuddy()
    {
      if (this.fetchingBuddy) return;

      try
      {
        this.fetchingBuddy = true;

        console.log("fetching buddy with id " + this.buddyId)
        let buddyInfo = await this.doApiRequest(() => new BuddyApi().getBuddy(this.buddyId));
        this.applyBuddyData(buddyInfo);

        if (this.buddyData.createdDate == null)
        {
          //this.buddyData = this.tempBuddy;
        }
        else
        {
          //this.buddyData = this.tempBuddy;
        }
      }
      catch (e)
      {
        console.log(e);

        await this.$router.push({
          name: "agenda"
        });
      }
      finally
      {
        this.fetchingBuddy = false;
      }
    },

    applyBuddyData(data)
    {
      let bodyPartIds = {
        'antennas': 'antenna',
        'eyes': 'eyes',
        'mouth': 'mouth',
        'nose': 'nose',
        'ears': 'ear_left',
        'markings': 'whiskers',
      }

      let accessoryIds = {
        accessory: "hand",
        head: "hat",
        legs: "pants",
        chest: "shirt",
        feet: "shoe_left",
      }

      for (const [ key, value ] of Object.entries(data))
      {
        if (value !== undefined)
        {
          if (key === 'body')
          {
            for (const [ key, value ] of Object.entries(data.body))
            {
              if (value !== undefined)
              {
                this.buddyData.bodyPartIds[bodyPartIds[key]] = value;

              }
            }
          }
          else if (key === 'outfit')
          {
            for (const [ key, value ] of Object.entries(data.outfit))
            {
              if (value !== undefined)
              {
                this.buddyData.accessoryIds[accessoryIds[key]] = value;

              }
            }
          }
          else
          {
            if (this.buddyData[key] !== undefined)
            {
              this.buddyData[key] = value;
            }
          }
        }
      }

      if (data.body.skinColor !== undefined)
      {
        this.buddyData.colors.buddy_primary = data.body.skinColor.primary;
        this.buddyData.colors.buddy_secondary = data.body.skinColor.secondary;
        this.buddyData.colors.buddy_tertiary = data.body.skinColor.tertiary;
      }


      if (data.outfit.colors !== undefined)
      {
        this.buddyData.colors.accessory_primary = data.outfit.colors.primary !== "" ? data.outfit.colors.primary : "rgb(155,171,209)";
        this.buddyData.colors.accessory_secondary = data.outfit.colors.secondary !== "" ? data.outfit.colors.secondary : "rgb(239,209,25)";
        this.buddyData.colors.accessory_tertiary = data.outfit.colors.tertiary !== "" ? data.outfit.colors.tertiary : "rgb(243,238,238)";
      }
      else
      {
        this.buddyData.colors.accessory_primary = "rgb(155,171,209)";
        this.buddyData.colors.accessory_secondary = "rgb(239,209,25)";
        this.buddyData.colors.accessory_tertiary = "rgb(243,238,238)";
      }

    },

    closePopup()
    {
      this.showOutro = false;
    }
  },
  async mounted()
  {
    this.buddyId = this.$route.params.id;
    console.log(`buddyId = ${this.buddyId}`)
    await this.fetchBuddy();

  }
}
</script>

<style lang="scss" scoped>
.card {
  background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  padding: 25px;
  margin-top: 25px;

  .title {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.3rem;
  }

  .subtitle {
    font-size: 1rem;
    font-style: italic;
    margin-bottom: 0.3rem;
  }

}
</style>